<template>
  <div class="page">
    <!-- 产品列表 -->
    <div class="productList" id="productList">
      <!-- 标题加产品类型卡片 用于粘性布局 -->
      <div class="productList-header">
        <!-- 标题 -->
        <div class="productList-title">
          <!-- 产品列表标题 -->
          <div>
            <span
              :style="
                depConfig.themeColor ? { background: depConfig.themeColor } : ''
              "
            ></span>
            <span>融资建议</span>
          </div>
          <!-- 选择地区 -->
          <div @click="$refs.areaList.show = true">
            <van-icon
              name="location"
              :color="depConfig.themeColor ? depConfig.themeColor : '#2841c1'"
            />

            <span
              :style="
                depConfig.themeColor
                  ? { color: depConfig.themeColor }
                  : { color: '#2841c1' }
              "
              >{{ areaTxt }}</span
            >
          </div>
        </div>
        <!-- 产品类型标签 -->
        <div class="productList-tabs">
          <!-- 产品标签1 -->
          <div class="item">
            <span
              :class="productTypeValue == 'hot' ? 'choice' : 'noChoice'"
              :style="
                productTypeValue == 'hot'
                  ? depConfig.themeColor
                    ? { background: depConfig.themeColor }
                    : ''
                  : ''
              "
              @click="choiceProductType('hot')"
            >
              热门产品</span
            >
            <span
              :class="productTypeValue == '' ? 'choice' : 'noChoice'"
              :style="
                productTypeValue == ''
                  ? depConfig.themeColor
                    ? { background: depConfig.themeColor }
                    : ''
                  : ''
              "
              @click="choiceProductType('')"
              >全部</span
            >
            <span
              v-for="(item, index) in productType"
              :key="index"
              :ref="item.value + 'tab'"
              :class="productTypeValue == item.value ? 'choice' : 'noChoice'"
              :style="
                productTypeValue == item.value
                  ? depConfig.themeColor
                    ? { background: depConfig.themeColor }
                    : ''
                  : ''
              "
              class="productType"
              @click="choiceProductType(item.value)"
              >{{ item.label }}</span
            >
          </div>
          <!-- 产品标签2 -->
          <div class="item" v-if="showMoreOptionFlag">
            <span
              v-for="(item, index) in productType2"
              :key="index"
              :ref="item.value + 'tab2'"
              :class="productType2Value == item.value ? 'choice' : 'noChoice'"
              :style="
                productType2Value == item.value
                  ? depConfig.themeColor
                    ? { background: depConfig.themeColor }
                    : ''
                  : ''
              "
              @click="choiceProductType2(item.value)"
              >{{ item.label }}</span
            >
          </div>
        </div>
      </div>
      <!-- 产品卡片 -->
      <div class="productList-content">
        <div
          class="item"
          v-for="(item, index) in productList"
          :key="index"
          @click="toProductDetail(item.id)"
          :style="item.tag ? { paddingTop: '10vw' } : ''"
        >
          <!-- 标签 例如：最新、最热 -->
          <div class="tag" v-show="item.tag">
            <span
              :style="
                depConfig.themeColor ? { background: depConfig.themeColor } : ''
              "
              >{{ item.tag }}</span
            >
          </div>
          <div class="top">
            <div class="left">
              <div class="left-left">
                <!-- 产品图标 -->
                <img :src="item.productLog" alt="" />
              </div>
              <!-- 产品名称 -->
              <div class="left-right">
                {{ item.productName }}
              </div>
            </div>
            <div class="right">
              <span
                :style="
                  depConfig.themeColor
                    ? {
                        color: depConfig.themeColor,
                        borderColor: depConfig.themeColor,
                      }
                    : ''
                "
                >立即申请</span
              >
            </div>
          </div>
          <div
            class="center"
            v-show="item.advantage1 || item.advantage2 || item.advantage3"
          >
            <!-- 特点1 -->
            <div v-show="item.advantage1">
              <img
                src="https://static.xchengtech.cn/e61ca91acd4842c9a9664ec461b679e9.png"
                alt=""
              />
              <span v-show="item.advantage1">{{ item.advantage1 }}</span>
            </div>
            <!-- 特点2 -->
            <div v-show="item.advantage2">
              <img
                src="https://static.xchengtech.cn/f625f3102bab47198bbc5994badf7dba.png"
                alt=""
              />
              <span>{{ item.advantage2 }}</span>
            </div>
            <!-- 特点3 -->
            <div v-show="item.advantage3">
              <img
                src="https://static.xchengtech.cn/8fe10c97dfab4f2fbb7c70295bba45c3.png"
                alt=""
              />
              <span>{{ item.advantage3 }}</span>
            </div>
          </div>
          <div class="bottom">
            <div v-show="item.maxLine">
              <span>{{ item.maxLine }}万</span>
              <span
                class="blueColor"
                :style="
                  depConfig.themeColor
                    ? {
                        color: depConfig.themeColor,
                        borderColor: depConfig.themeColor,
                      }
                    : ''
                "
                >最高额度</span
              >
            </div>
            <div v-show="item.minLine && item.type == 'FYL'">
              <span>{{ item.minLine }}万起</span>
              <span class="blueColor">授信额度</span>
            </div>
            <!-- 最高最低利率都存在时 -->
            <div v-show="item.minRate && item.maxRate">
              <span>{{ item.minRate }}%-{{ item.maxRate }}%</span>
              <span>年化利率</span>
            </div>
            <!-- 只有最高利率 -->
            <div v-show="!item.minRate && item.maxRate">
              <span>{{ item.maxRate }}%</span>
              <span>最高利率</span>
            </div>
            <!-- 只有最低利率 -->
            <div v-show="item.minRate && !item.maxRate">
              <span>{{ item.minRate }}%</span>
              <span>最低利率</span>
            </div>
            <div v-show="item.period">
              <span>{{ item.period }}月</span>
              <span>借款周期</span>
            </div>
          </div>
        </div>
        <van-empty v-show="!productList[0]" description="无符合产品" />
      </div>
    </div>
    <areaList ref="areaList"></areaList>
  </div>
</template>

<script>
import { getProductList } from "@/api/product.js";
import { getCus as cusGetDict } from "@/api/dictDetail.js";
import { Icon, Tab, Tabs, Toast } from "vant";
import areaList from "./areaList";
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Icon);
import Vue from "vue";

export default {
  components: { areaList },
  props: {
    depConfig: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  mounted() {
    // 获取产品类型标签
    this.getProductType();
    // 获取产品类型2的标签
    this.getProductType2();
  },
  data() {
    return {
      //   查询参数
      params: {
        type: null,
        status: null,
        productName: null,
        hotFlag: true,
        cityCode: null,
      },
      //   产品类型1
      productType: [],
      //   产品类型2
      productType2: [],
      //   产品类型1标识
      productTypeValue: "hot",
      //   产品类型2标识
      productType2Value: "",
      //   产品列表（实际展示所用的数据）
      productList: [],
      //   显示更多
      showMoreOptionFlag: true,
      //   原始产品数据 判断标签
      productTypeForShow: [],
      productType2ForShow: [],
      //   全部产品的数据
      allProductData: [],
      // 选择地区 文本
      areaTxt: "全国",
    };
  },
  methods: {
    // 获取产品类型
    getProductType() {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "加载中",
      });
      cusGetDict("product_type")
        .then((res) => {
          res.sort((a, b) => {
            return a.sort - b.sort;
          });
          this.productType = this.productType.concat(res);
          // 获取产品列表 默认查询热门产品
          this.getProductList();
          // 获取全部产品 用于判断标签显示
          this.getAllProductList();
        })
        .catch((err) => {
          console.log("err", err);
          Toast.clear();
        });
    },
    // 获取产品类型
    getProductType2() {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "加载中",
      });
      cusGetDict("product_second_type")
        .then((res) => {
          res.sort((a, b) => {
            return a.sort - b.sort;
          });
          this.productType2 = res;
        })
        .catch((err) => {
          console.log("err", err);
          Toast.clear();
        });
    },
    // 获取产品列表
    getProductList() {
      for (let key in this.params) {
        if (!this.params[key]) delete this.params[key];
      }
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "加载中",
      });
      getProductList(this.params)
        .then((res) => {
          res.sort((a, b) => {
            return b.sort - a.sort;
          });
          this.productList = res.filter((item) => {
            return item.status == "up";
          });
          // 产品标签为全部，并且不是热门产品时
          if (
            !this.params.type &&
            !this.params.hotFlag &&
            !this.params.secondType
          ) {
            // 更新全部产品的原始数据
            this.allProductData = this.productList;
            // 重新判断产品标签显示
            this.productTypeIsShow();
            // 判断哪些二级标签要显示
            this.productType2IsShow();
          }
          Toast.clear();
        })
        .catch((err) => {
          console.log("err", err);
          Toast.clear();
        });
    },
    // 获取全部产品 并且判断哪些标签要显示
    getAllProductList() {
      getProductList()
        .then((res) => {
          res.sort((a, b) => {
            return b.sort - a.sort;
          });
          this.allProductData = res.filter((item) => {
            return item.status == "up";
          });
          // 判断哪些标签要显示
          this.productTypeIsShow();
          // 判断哪些二级标签要显示
          this.productType2IsShow();
        })
        .catch((err) => {
          console.log("err", err);
          Toast.clear();
        });
    },
    // 查看产品详情
    toProductDetail(id) {
      this.$router.push({
        path: "/productDetail",
        query: { productId: id },
      });
    },
    // 处理产品类型标签，判断是否显示
    productTypeIsShow() {
      // 清空显示的产品标签
      this.productTypeForShow = [];
      // 在全部产品中获取需要显示的产品标签
      this.allProductData.forEach((item) => {
        if (item.type && item.status == "up") {
          if (this.productTypeForShow.indexOf(item.type) < 0) {
            this.productTypeForShow.push(item.type);
          }
        }
      });
      // 遍历产品类型，显示指定产品标签
      this.productType.forEach((item) => {
        if (this.productTypeForShow.indexOf(item.value) > -1) {
          this.$refs[item.value + "tab"][0].style.display = "block";
        } else {
          this.$refs[item.value + "tab"][0].style.display = "none";
        }
      });
    },
    // 处理产品类型标签2，判断是否显示
    productType2IsShow() {
      // 清空显示的产品标签
      this.productType2ForShow = [];
      // 在全部产品中获取需要显示的产品标签
      this.allProductData.forEach((item) => {
        if (item.secondType && item.status == "up") {
          if (this.productType2ForShow.indexOf(item.secondType) < 0) {
            this.productType2ForShow.push(item.secondType);
          }
        }
      });
      if (this.productType2ForShow.length == 0) {
        this.showMoreOptionFlag = false;
      }

      // 遍历产品类型，显示指定产品标签
      this.productType2.forEach((item) => {
        if (this.productType2ForShow.indexOf(item.value) > -1) {
          this.$refs[item.value + "tab2"][0].style.display = "block";
        } else {
          this.$refs[item.value + "tab2"][0].style.display = "none";
        }
      });
    },
    scrollToDiv(divId) {
      var div = document.getElementById(divId);
      div.scrollIntoView({ behavior: "smooth", block: "start" });
    },
    // 选择产品类型
    choiceProductType(value) {
      // 判断是否重复点击
      if (this.productTypeValue != value) {
        if (value == "hot") {
          this.params.hotFlag = true;
          this.params.type = "";
        } else {
          this.params.hotFlag = false;
          this.params.type = value;
        }
        this.productTypeValue = value;
        this.productType2Value = "";
        this.params.secondType = "";
        this.scrollToDiv("productList");
        this.getProductList();
      }
    },
    // 选择筛选标签
    choiceProductType2(value) {
      if (this.productType2Value != value) {
        this.productType2Value = value;
        this.params.secondType = value;
        this.params.hotFlag = false;
        this.params.type = "";
        this.productTypeValue = null;
        this.scrollToDiv("productList");
        this.getProductList();
      }
    },
    // 产品名称搜索
    onSearch() {
      this.scrollToDiv("productList");
      this.getProductList();
    },
  },
};
</script>

<style scoped>
/* 引入现代字体 */
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=Outfit:wght@500;700&display=swap");

.page {
  /* gap: 4vw; */
}
.productList {
  /* background: linear-gradient(180deg, #ebf3ff 0%, #f5f7fa 100%); */
  background-color: #f7f7f9;
}
.productList-header {
  position: sticky;
  top: 0;
  left: 0;
  padding: 0 4vw;

  padding-top: 4vw;
  background-color: #f7f7f9;
  z-index: 99;
}
.productList .productList-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 3vw;
}
.productList .productList-title div:nth-of-type(1) {
  display: flex;
  align-items: center;

  gap: 2vw;
}
.productList .productList-title div:nth-of-type(2) {
  font-weight: 600;
}

.productList .productList-title div:nth-of-type(1) span:nth-of-type(1) {
  display: inline-block;
  height: 3vw;
  width: 4px;
  background-color: #2841c1;
  border-radius: 4px;
}

.productList .productList-title div:nth-of-type(1) span:nth-of-type(2) {
  font-size: 4.2vw;
  font-weight: 600;
}

/* 产品类型标签 */
.productList .productList-tabs {
}

.productList .productList-tabs .van-search__content {
  background-color: white;
}

.productList-tabs .item:nth-of-type(1),
.productList-tabs .item:nth-of-type(2) {
  display: flex;
  width: 100%;
  gap: 3vw;
  overflow-x: auto;
  padding-bottom: 4vw;
}

.productList-tabs .item:nth-of-type(1) span {
  /* display: block; */
  border-radius: 35px;
  padding: 2vw 4vw;
  /* min-width: 22vw; */
  box-sizing: border-box;
  text-align: center;
  font-size: 3.4vw;
  white-space: nowrap;
  border: 1px solid #eee;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
}

.productList-tabs .item:nth-of-type(2) span {
  display: block;
  border-radius: 35px;
  padding: 2vw 4vw;
  /* min-width: 22vw; */
  box-sizing: border-box;
  text-align: center;
  font-size: 3.4vw;
  white-space: nowrap;
  border: 1px solid #eee;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
}

.productList-tabs .item:nth-of-type(1)::-webkit-scrollbar,
.productList-tabs .item:nth-of-type(2)::-webkit-scrollbar {
  display: none;
}

.productList-tabs .item:nth-of-type(3) {
  padding-bottom: 4vw;
  /* justify-content: space-between; */
}

.productList-tabs .item:nth-of-type(3) .left {
  width: 100%;
}

.productList-tabs .item:nth-of-type(3) .van-search {
  padding: 0;
  font-size: 14px !important;
  width: 100%;
  background-color: #f7f7f9;
}

.productList-tabs .item:nth-of-type(3) .van-search__action {
  /* background-color: white; */
  padding: 0 0 0 4vw;
}

.productList-tabs .item:nth-of-type(3) .right-btn {
  height: 100%;
  display: flex;
  align-items: center;
  gap: 20px;
}

.productList-tabs .item:nth-of-type(3) .right-btn .right div {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  font-weight: 600;
  color: #4988fd;
  white-space: nowrap;
}

.productList-tabs .item:nth-of-type(3) .right-btn .right .van-icon {
  font-weight: 600;
  font-size: 14px;
}

.productType {
  display: none;
}

.choice {
  background: #2841c1;
  font-weight: 500;
  color: white;
}

.noChoice {
  background: white;
  color: #667799;

  font-weight: 500;
}

/* 产品列表 */

.productList .productList-content {
  display: grid;
  gap: 4vw;
  padding: 0 4vw 21vw 4vw;
}

.productList-content .item {
  position: relative;
  padding: 5vw;
  background-color: #fff;
  border-radius: 20px;
  box-shadow: 0 4px 12px -2px rgba(26, 60, 120, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.02);
}

.productList .productList-content .item .tag {
  position: absolute;
  top: 0;
  left: 5vw;
}
.productList .productList-content .item .tag span {
  display: inline-block;
  background-color: #2841c1;
  font-size: 3.6vw;
  padding: 0.6vw 2.6vw;
  color: white;
  border-radius: 0 0 8px 8px;
  font-weight: 600;
}

.productList-content .item .top {
  display: grid;
  grid-template-columns: auto 24vw;
  align-items: center;
  padding-bottom: 4vw;
}

.productList-content .item .top .left {
  display: flex;
  align-items: center;
}

/* 产品图标 */
.productList-content .item .top .left .left-left {
  padding-right: 3vw;
}

.productList-content .item .top .left .left-left img {
  display: block;
  width: 12vw;
  margin: 0 auto;
}

.productList-content .item .top .left .left-right {
  display: grid;
  align-items: center;
  gap: 2vw;
}

/* 产品名称 */
.productList-content .item .top .left .left-right {
  font-size: 4.6vw;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 700;
}

/* 产品优势 */
.productList-content .item .center {
  width: 100%;
  display: flex;
  gap: 2vw;
  padding-bottom: 4vw;
}

.productList-content .item .center div {
  display: flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 6px;
  gap: 1vw;
  font-size: 3vw;
  font-weight: 600;
}

.productList-content .item .center div img {
  display: block;
  height: 2.4vw;
}

/* 产品优势 第一个 */
.productList-content .item .center div:nth-of-type(1) {
  color: #10b981;
  background: #ecfdf5;
}
/* 产品优势 第二个 */
.productList-content .item .center div:nth-of-type(2) {
  color: #3b82f6;
  background: #eff6ff;
}
/* 产品优势 第三个 */
.productList-content .item .center div:nth-of-type(3) {
  background-color: #ffefdf;
  color: #fd910a;
}

.van-empty {
  padding: 0;
}

/* 立即申请按钮 */
.productList-content .item .top .right {
}

.productList-content .item .top .right span {
  display: block;
  border-radius: 35px;
  padding: 2vw 4vw;
  border: 1px solid #2841c1;
  color: #2841c1;
  text-align: center;
  font-weight: 600;
}

/* 产品卡片底部信息 */
.productList-content .item .bottom {
  border-top: 1px solid #efefef;
  padding-top: 4vw;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  justify-content: center;
  text-align: center;
  gap: 4vw;
}

.productList-content .item .bottom div {
  display: grid;
  gap: 1vw;
}

.productList-content .item .bottom div span:nth-of-type(1) {
  /* color: #989898; */
  font-size: 4.6vw;
  font-weight: 700;
  color: #1b2232;
  font-family: "Outfit", sans-serif;
}

.productList-content .item .bottom div span:nth-of-type(2) {
  /* font-size: 4vw; */
  font-size: 3vw;
  color: #667799;
}

.blueColor {
  color: #2841c1;
}
</style>


// WEBPACK FOOTER //
// src/view/productList/module/productList.vue